import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function changeRegion(region: string): RootActionTypes {
  return {
    type: ActionTypes.CHANGE_REGION,
    payload: region,
  };
}
